module.exports = __webpack_public_path__ + "img/chinesecompany65.816d3590.png";